export default "__VITE_ASSET__BM$qugVk__"